import React from "react";
import { useEffect } from "react";
import BTKhusus from "../../components/BukuTanah/BTKhusus";

const Khusus = () => {
  useEffect(() => {
    document.title = "BT Khusus";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="p-6">
      <BTKhusus/>
    </div>
  );
};

export default Khusus;
